/** 动态路由状态，独立模块避免循环依赖 */
export const dynamicRouteState = {
  added: false,
  paths: [] as string[],
};
